import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';



// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {
};

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectIconsComponent),
  multi: true
};


@Component({
  selector: 'lcms-select-icons',
  templateUrl: './select-icons.component.html',
  styleUrls: ['./select-icons.component.scss'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]

})
export class SelectIconsComponent  implements  ControlValueAccessor,OnChanges{

  @Input() open:boolean;
  @Input() same_state:boolean| null;
  @Input() isDirty:boolean| null;
  @Input() status:any;
  menuMode:boolean | null = null

  @Output() permissionChanged = new EventEmitter<boolean | null>()

 public display = false

  private innerValue = null;
  isBackward = false;

  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;


  //get accessor
  get valuePermission(): any {
    return this.innerValue;
  }

  //set accessor including call the onchange callback
  set valuePermission(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      if (this.innerValue === true) this.isBackward = false;
      if (this.innerValue === false) this.isBackward = true;
      this.onChangeCallback(v);
    }
  }

  //From ControlValueAccessor interface
  writeValue(value: any) {
    if (value !== this.innerValue) {
      this.innerValue = value;
      if (this.innerValue === true) this.isBackward = false;
      if (this.innerValue === false) this.isBackward = true;
      this.permissionChanged.emit(value);
      this.onChangeCallback(value);
    }
  }
  //From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['status']) {
      this.writeValue(changes['status'].currentValue);
    }
  }

}
